import 'core-js/es';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import moment from 'moment';
import ReactDOM from 'react-dom';
import Container from './container';
import reportWebVitals from './reportWebVitals';
import './assets/style/index.less';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

ReactDOM.render(
    <ConfigProvider locale={zhCN}>
        <Container />
    </ConfigProvider>,
    document.getElementById('root'),
);

reportWebVitals();
